/*******************************************************************************
 * Adjustments/JournalEntries Services
 *******************************************************************************/
/* @ngInject */ export function AdjustmentsServices(HTTPService) {
  var http = HTTPService.make('/adjustments/');

  this.findAdjustments = (filters) => http.post('findAdjustments', filters);
  this.getAdjustment = (id, dir) => http.get(`getAdjustment/${id}/${dir}`);
  this.getNextAdjustmentNumber = () => http.get('getNextAdjustmentNumber');
  this.saveAdjustment = (adjustment) =>
    http.post('saveAdjustment', adjustment);
  this.voidAdjustment = (voidEntry) => http.post('voidAdjustment', voidEntry);
}
